export default __webpack_public_path__ + "static/media/no-project.7e033885.svg";